module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Table', {
    ref: "table",
    attrs: {
      "border": "",
      "height": _vm.height,
      "columns": _vm.innerColumns,
      "data": _vm.tableData,
      "stripe": "",
      "size": "large"
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('Page', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "total": _vm.totalCount,
      "show-elevator": "",
      "className": "page",
      "current": _vm.page.pageIndex,
      "pageSize": _vm.page.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePageIndex
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84c862ce","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/RecommendList.vue
// module id = 1892
// module chunks = 8